import React from 'react'
import { WaitlistContext, type WaitlistContextType } from './_context'

export function useWaitlist(): WaitlistContextType {
  const context = React.useContext(WaitlistContext)

  if (context === undefined) {
    throw new Error('useWaitlist must be used within a WaitlistProvider')
  }

  return context
}
